export const SET_SEARCH_MODE = 'shopList/SET_SEARCH_MODE';
export const SET_SEARCH_PARAMS = 'shopList/SET_SEARCH_PARAMS';
export const SET_FILTERS = 'shopList/SET_FILTERS';
export const CLEAR_FILTERS = 'shopList/CLEAR_FILTERS';

export const FETCH_SHOPS_REQUEST = 'shopList/FETCH_SHOPS_REQUEST';
export const FETCH_SHOPS_SUCCESS = 'shopList/FETCH_SHOPS_SUCCESS';
export const FETCH_SHOPS_FAILURE = 'shopList/FETCH_SHOPS_FAILURE';
export const FETCH_SHOPS_INITIAL = 'shopList/FETCH_SHOPS_INITIAL';

export const TOGGLE_BOOKMARK = 'shopList/TOGGLE_BOOKMARK';
export const TOGGLE_BOOKMARK_SUCCESS = 'shopList/TOGGLE_BOOKMARK_SUCCESS';
export const TOGGLE_BOOKMARK_FAILURE = 'shopList/TOGGLE_BOOKMARK_FAILURE';

export const SET_SELECTED_SHOP = 'shopList/SET_SELECTED_SHOP';
export const FETCH_CURRENT_LOCATION = 'shopList/FETCH_CURRENT_LOCATION';
export const SET_CURRENT_LOCATION = 'shopList/SET_CURRENT_LOCATION';

export const FETCH_FILTER_OPTIONS = 'shopList/FETCH_FILTER_OPTIONS';
export const FETCH_FILTER_OPTIONS_SUCCESS = 'shopList/FETCH_FILTER_OPTIONS_SUCCESS';
export const FETCH_FILTER_OPTIONS_FAILURE = 'shopList/FETCH_FILTER_OPTIONS_FAILURE';

export const FETCH_AREA_OPTIONS = 'shopList/FETCH_AREA_OPTIONS';
export const FETCH_AREA_OPTIONS_SUCCESS = 'shopList/FETCH_AREA_OPTIONS_SUCCESS';
export const FETCH_AREA_OPTIONS_FAILURE = 'shopList/FETCH_AREA_OPTIONS_FAILURE';
